import axios from 'axios';

// var API_URL  = "http://3.111.82.112:3000/api/auth/";
// var API_URL  = "http://3.7.156.63/api/auth/";
// var API_URL = 'http://localhost:3000/api/auth/';
var API_URL = process.env.REACT_APP_API_AUTH_URL || '/api/auth/';

//  if (process.env.NODE_ENV === "production") {
//   API_URL = "https://codersarts-employee-dashboard.herokuapp.com/api/auth/";
// }else if(process.env.NODE_ENV === "development"){
//   API_URL = "http://52.66.212.70/api/auth/";

// }

const register = data => {
  return axios.post (API_URL + 'signup', {
    data,
  });
};

const sendSignupOtp = data => {
  return axios.post (API_URL + 'send-signup-otp', {
    data,
    turnstileToken: data.turnstileToken,
  });
};

const login = async (username, password, turnstileToken) => {
  // console.log("Data : ",username);
  return axios
    .post (API_URL + 'signin', {
      username,
      password,
      turnstileToken,
    })
    .then (response => {
      if (response.data.accessToken) {
        localStorage.setItem ('user', JSON.stringify (response.data));
      }
      return response.data;
    });
};

const loginWithPhone = async phoneNumber => {
  // console.log("Data : ",username);
  return axios
    .post (API_URL + 'login-with-phonenumber', {
      phoneNumber,
    })
    .then (response => {
      if (response.data.accessToken) {
        localStorage.setItem ('user', JSON.stringify (response.data));
      }
      return response.data;
    });
};

const sendOtpToPhone = phone => {
  return axios
    .post (API_URL + 'send-otp-sms', phone)
    .then (response => {
      return response;
    })
    .catch (error => {
      console.log (error);
    });
};

const logout = () => {
  localStorage.removeItem ('user');
};

export default {
  register,
  sendSignupOtp,
  login,
  logout,
  loginWithPhone,
  sendOtpToPhone,
};
